"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Node = void 0;
function Node(_astNode) {
    return new Proxy(_astNode, {
        get: function (target, prop, reciver) {
            // @ts-ignore
            if (target.hasOwnProperty(prop)) {
                // @ts-ignore
                return target[prop];
            }
            else {
                if (prop == "getAttribute") {
                    return function (name) {
                        var _attr = null;
                        if (_astNode.attrs) {
                            _astNode.attrs.every(function (attr) {
                                if (attr.name == name) {
                                    _attr = attr.value;
                                    return false;
                                }
                                return true;
                            });
                        }
                        return _attr;
                    };
                }
                else if (prop == "setAttribute") {
                    return function (name, value) {
                        var __found = false;
                        for (var i = 0; i < target.attrs.length; i++) {
                            var attr = target.attrs[i];
                            if (attr.name == name) {
                                target.attrs[i] = { name: attr.name, value: value };
                                __found = true;
                                return false;
                            }
                            return true;
                        }
                        if (!__found)
                            _astNode.attrs.push({ name: name, value: value });
                    };
                }
                else if (prop == "removeAttribute") {
                    return function (name) {
                        for (var i = 0; i < target.attrs.length; i++) {
                            var attr = target.attrs[i];
                            if (attr.name == name) {
                                delete target.attrs[i];
                                return false;
                            }
                            return true;
                        }
                    };
                }
            }
        }
    });
}
exports.Node = Node;
